// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"134":"c5df5bb2","527":"411c1812","605":"cdecc9c8","718":"5a6daa9a","725":"8c7942be","741":"26037ae5"}[chunkId] + ".chunk.js";
};